<div class="mat-elevation-z2">
  <table 
   mat-table class="full-width-table"
       matSortActive="updated_at"
    matSortDirection="desc"
    matSortDisableClear="true"
   matSort aria-label="Elements">
    <!-- Bundle Version Column -->
    <ng-container matColumnDef="bundle_version">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>BUNDLE VERSION</th>
      <td mat-cell *matCellDef="let row">{{row.version}}</td>
    </ng-container>

    <!-- State Column -->
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>STATE</th>
      <td mat-cell *matCellDef="let row">{{row.state}}</td>
    </ng-container>

    <!-- Description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>DESCRIPTION</th>
      <td mat-cell *matCellDef="let row">{{row.description}}</td>
    </ng-container>

    <!-- used in rollout Column -->
    <ng-container matColumnDef="used_in_rollout_plans">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>USED IN ROLLOUT PLANS</th>
      <td mat-cell *matCellDef="let row">{{row.numberOfRollouts
        }}</td>
    </ng-container>

    <!-- Updated At Column -->
    <ng-container matColumnDef="updated_at">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>UPDATED AT</th>
      <td mat-cell *matCellDef="let row">
        {{ row.updatedAt | formatDateTime }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr (click)="goToDetails(row)" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="10"
    [pageSizeOptions]="[5, 10, 20]" aria-label="Select page">
  </mat-paginator>
</div>